export default __webpack_public_path__ + "static/media/flag-ukraine.6c0a1f08.svg";